import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

export function customMatIconsInitializerFactory(
  matIconRegistry: MatIconRegistry,
  domSanitizer: DomSanitizer
): () => Promise<void> {
  return () =>
    new Promise((resolve) => {
      matIconRegistry.addSvgIcon(
        'no-icon',
        domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/main-icons/no-icon.svg')
      );
      matIconRegistry.addSvgIcon(
        'breece-add',
        domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/main-icons/Add.svg')
      );
      matIconRegistry.addSvgIcon(
        'breece-forward',
        domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/main-icons/no-icon.svg')
      );
      matIconRegistry.addSvgIcon(
        'breece-backwards',
        domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/main-icons/no-icon.svg')
      );
      matIconRegistry.addSvgIcon(
        'breece-filter-active',
        domSanitizer.bypassSecurityTrustResourceUrl('"assets/icons/main-icons/Filter_active_main.svg"')
      );
      matIconRegistry.addSvgIcon(
        'mat-folder',
        domSanitizer.bypassSecurityTrustResourceUrl('"assets/icons/mat-icons/folder.svg"')
      );
      matIconRegistry.addSvgIcon(
        'breece-download',
        domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/mat-icons/download.svg')
      );
      matIconRegistry.addSvgIcon(
        'breece-logs',
        domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/mat-icons/draft.svg')
      );
      matIconRegistry.addSvgIcon(
        'breece-no-filter',
        domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/main-icons/Filter_deactive_main.svg')
      );
      matIconRegistry.addSvgIcon(
        'breece-edit-filter',
        domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/main-icons/Filter_active_main.svg')
      );
      matIconRegistry.addSvgIcon(
        'breece-filter',
        domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/main-icons/Filter.png')
      );
      matIconRegistry.addSvgIcon(
        'breece-card-view',
        domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/main-icons/Card_view.svg')
      );
      matIconRegistry.addSvgIcon(
        'breece-list-view',
        domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/main-icons/List_view.svg')
      );
      // Batteries
      matIconRegistry.addSvgIcon(
        'battery-unknown',
        domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/main-icons/battery/Unknown_battery.svg')
      );
      matIconRegistry.addSvgIcon(
        'battery-good',
        domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/main-icons/battery/Good_battery.svg')
      );
      matIconRegistry.addSvgIcon(
        'battery-low',
        domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/main-icons/battery/Low_battery.svg')
      );
      matIconRegistry.addSvgIcon(
        'battery-replace',
        domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/main-icons/battery/Replace_battery.svg')
      );
      matIconRegistry.addSvgIcon(
        'battery-empty',
        domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/main-icons/battery/Empty_battery.svg')
      );
      // Signal level (Hanshow): 0-4 filled bars
      matIconRegistry.addSvgIcon(
        'signal-0',
        domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/main-icons/signal/Signal_0.svg')
      );
      matIconRegistry.addSvgIcon(
        'signal-1',
        domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/main-icons/signal/Signal_1.svg')
      );
      matIconRegistry.addSvgIcon(
        'signal-2',
        domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/main-icons/signal/Signal_2.svg')
      );
      matIconRegistry.addSvgIcon(
        'signal-3',
        domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/main-icons/signal/Signal_3.svg')
      );
      matIconRegistry.addSvgIcon(
        'signal-4',
        domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/main-icons/signal/Signal_4.svg')
      );
      matIconRegistry.addSvgIcon(
        'signal-off',
        domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/main-icons/signal/Signal_off.svg')
      );
      matIconRegistry.addSvgIcon(
        'breece-display',
        domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/main-icons/display/Display.svg')
      );
      matIconRegistry.addSvgIcon(
        'app-store',
        domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/get-app/apple.svg')
      );
      matIconRegistry.addSvgIcon(
        'play-store',
        domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/get-app/play.svg')
      );
      resolve();
    })
}
